<!-- <pre style="background-color: yellow">
isEnterprise(): {{ sessionService.isEnterprise() }}</pre
> -->
@if(!sessionService.isEnterprise()){
<!-- Start::título -->
<div class="field mb-4">
  <span class="text-900 text-2xl block font-semibold mb-5"
    >Ingresa la información de facturación</span
  >
</div>
<!-- End::título -->

<!-- Start::descripción -->
<!--<div
  class="p-4 mt-3 surface-100 flex align-items-center justify-content-between mb-4"
>
  <span class="mr-3 md:mr-5 text-sm"
    >Aseguráte de ingresar los datos exactos de tu empresa para evitar
    errores.</span
  >
  <i class="fa-sharp-duotone fa-solid fa-circle-info text-4xl"></i>
</div>-->
<!-- End::descripción -->

<form
  [formGroup]="invoiceForm"
  #invoiceFormElement
  (ngSubmit)="nativeSubmit()"
>
  <!-- Start::input documentId -->
  <!--<pre style="background-color: yellow">
  invoiceForm: {{ invoiceForm.value | json }}
</pre
  >
  <pre style="background-color: pink">
    lastValue: {{ lastValue() }}
    hasAsyncData: {{ hasAsyncData() }}
    businessName: {{ businessName() }}
    businessLines: {{ businessLines() | json }}
  </pre>
  <pre style="background-color: aquamarine">
    invoiceAddress: {{ invoiceAddress() | json }}
  </pre>--->
  <div class="field mb-4 flex flex-column">
    <label for="documentId" class="font-semibold text-900">{{
      documentIdLabel
    }}</label>
    <app-document-id-input
      id="documentId"
      formControlName="documentId"
      [isBusiness]="true"
      [asyncValidationType]="documentIdAsyncValidationType"
      [useCaptcha]="true"
    />
    <!--   [isLoadingStatus]="isLoadingBusiness" -->
    <!--    (blur)="getBusiness($event)" -->

    <small id="documentId-help"> Ej: {{ documentIdSample }}</small>
  </div>
  <!-- End::input documentId -->

  <!--<pre style="background-color: yellow">
    isLoadedBusiness: {{ isLoadedBusiness() }}
  </pre> -->
  @if(isLoadedBusiness()){
  <!-- Start::input razón social -->
  <div class="field mb-4 flex flex-column">
    <label for="businessName" class="font-semibold text-900"
      >Razón social o nombre de la empresa</label
    >
    <p-iconField iconPosition="right">
      <p-inputIcon
        styleClass="fa-sharp fa-solid fa-spinner-third fa-spin"
        [hidden]="!isLoading()"
      />
      <input
        #businessNameInputElement
        id="businessName"
        type="text"
        pInputText
        maxlength="20"
        formControlName="businessName"
      />
    </p-iconField>
  </div>
  <!-- End::input razón social -->

  <!-- Start::giro comercial -->
  <div class="field mb-5 flex flex-column">
    <label for="businessLine" class="font-semibold text-900"
      >Giro comercial</label
    >
    <p-dropdown
      #businessLineInputElement
      styleClass="w-full"
      formControlName="businessLineCode"
      [options]="businessLines()"
      optionLabel="name"
      optionValue="code"
      [loading]="isLoading()"
      dropdownIcon="fa-sharp fa-solid fa-chevron-down"
      loadingIcon="fa-sharp fa-solid fa-spinner-third fa-spin"
      [filter]="true"
      filterBy="name"
      emptyMessage="No se encontraron giros comerciales"
      emptyFilterMessage="No se encontraron giros comerciales"
    />
  </div>
  <!-- End::giro comercial -->

  <!-- Start::input email -->
  <div class="field mb-4 flex flex-column">
    <label for="documentId" class="font-semibold text-900"
      >Correo electrónico de contacto de la empresa</label
    >
    <app-email-input formControlName="email" id="email" />
    <small id="email-help"> Ej: micorreo&#64;gmail.com </small>
  </div>
  <!-- End::input email -->
  }
</form>

@if(isLoadedBusiness()){
<app-invoice-address-form
  #invoiceAddressFormComponent
  [useDeliveryAddress]="useDeliveryAddress()"
  (onUseDeliveryAddressChange)="onUseDeliveryChange($event)"
  [isLoadedBusiness]="isLoadedBusiness()"
  [isRegisteredBusiness]="isRegisteredBusiness()"
  [selectedAddress]="invoiceAddress()"
/>
<!-- [invoiceAddresses]="invoiceAddresses()" -->

} }
